<template>
  <pt-link-manage class="pt-link-manage__page"></pt-link-manage>
</template>

<script>
import PtLinkManage from 'cps//pt-link-manage/withData'
export default {
  name: 'pt-link-manage__view',
  components: {
    'pt-link-manage': PtLinkManage
  }
}
</script>
